import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";

import { quoteRequestsV2Query } from "#modules/quoteRequestsV2/infra/quoteRequests.v2.query";

const DEFAULT_PAGE = 1;
export const DEFAULT_PER_PAGE = 25;

const parsePage = (value: string | null) => {
  const page = Number(value);
  if (!Number.isInteger(page) || page < 1) {
    return DEFAULT_PAGE;
  }
  return page;
};

export const useQuoteRequestsV2 = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const page = parsePage(searchParams.get("page"));

  const { data: queryData, ...rest } = useQuery({
    ...quoteRequestsV2Query({ page, perPage: DEFAULT_PER_PAGE }),
  });

  const setPagination = ({ page: nextPage }: { page: number }) => {
    setSearchParams(
      (prev) => {
        const params = new URLSearchParams(prev);
        if (nextPage <= DEFAULT_PAGE) {
          params.delete("page");
        } else {
          params.set("page", String(nextPage));
        }
        return params;
      },
      { replace: true },
    );
  };

  return {
    quoteRequests: queryData?.data ?? [],
    metadata: queryData?.metadata,
    setPagination,
    page,
    ...rest,
  };
};
